import { CalendarCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { BRAND } from "@/lib/siteData";

export const FinalCta = () => {
  return (
    <section className="relative bg-background pb-24 pt-4 lg:pb-32">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <Reveal dir="scale">
          <div className="relative overflow-hidden rounded-[2rem] bg-gradient-navy px-6 py-16 text-center shadow-elegant sm:px-12 lg:py-20">
            <div className="absolute inset-0 grid-pattern opacity-30" />
            <div className="absolute -left-10 top-0 h-52 w-52 rounded-full bg-techblue/25 blur-3xl" />
            <div className="absolute -right-10 bottom-0 h-52 w-52 rounded-full bg-techblue-glow/20 blur-3xl" />

            <div className="relative">
              <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5 text-xs font-medium text-techblue-glow">
                <span className="flex h-1.5 w-1.5 rounded-full bg-techblue-glow animate-pulse-glow" />
                {BRAND.tagline}
              </div>
              <h2 className="mx-auto max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight text-navy-foreground sm:text-4xl lg:text-5xl">
                Ready to Take Control of Your Website?
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-base text-navy-muted md:text-lg">
                Join business owners who stopped waiting on developers — and started managing their
                own success.
              </p>
              <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Button asChild variant="cta" size="xl">
                  <a href="#demo">
                    <CalendarCheck className="h-4 w-4" /> Schedule a Demo
                  </a>
                </Button>
                <Button asChild variant="hero" size="xl">
                  <a href="#preview">
                    See the Platform in Action <ArrowRight className="h-4 w-4" />
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
